/* eslint-disable react-hooks/exhaustive-deps */
import { useExperiments } from 'ppbl/hooks'
import React, { useEffect } from 'react'
import { navigate } from '@reach/router'
import serverData from 'ppbl/utils/server-data'
import { isEmpty } from 'lodash-es'
import clientLogger from 'ppbl/utils/client-logger'
import { UTM_CAMPAIGN } from 'ppbl/utils/constants'
import { trackPage } from 'ppbl/utils/fpti-helper'

/**
 * This is a functional component that handles campaign redirection of users
 * @returns {JSX.Element} - A JSX element
 */
const PPBLCampaignRedirectionHelper = () => {
  const { ppbl_ui_newlook_experience = 'control' } = useExperiments()
  const isNewExperience = ppbl_ui_newlook_experience === 'treatment_1'

  const ppblCampaignIdentifier = sessionStorage.getItem(
    'ppbl_campaign_transition',
  )

  const serverSideData = serverData.data

  const oldApplicationURI = serverSideData?.oldApplicationURI
  const baseUri = serverSideData?.baseUri
  const queryParamsString = serverSideData?.ppblUrlQueryParams

  const appConfig = serverSideData.appConfig.application
  const oldUrl = oldApplicationURI.replaceAll('/', '%2f')

  const utmCampaignId = sessionStorage.getItem(UTM_CAMPAIGN)

  useEffect(() => {
    let redirectUri

    if (ppblCampaignIdentifier || !isNewExperience) {
      redirectUri = `${appConfig.paypalConnectDomain}/connect/?${appConfig.paypalConnectClientIdString}&response_type=code&redirect_uri=${oldUrl}%2fpaypal%2fstart`
      const logDetails = `Redirecting to OLD application. Campaign id: ${utmCampaignId}`
      clientLogger.info(logDetails)
      const fptiData = {
        page: 'PPBLCampaignRedirectionHelper',
        pageDetails: logDetails,
      }
      trackPage(fptiData)
      sessionStorage.removeItem(UTM_CAMPAIGN)

      window.location.assign(redirectUri)
    } else {
      redirectUri = `${baseUri}/us/paypal/start`

      if (!isEmpty(queryParamsString)) {
        redirectUri += `?${queryParamsString}`
      }

      const logDetails = `Redirecting to start route. Campaign id: ${utmCampaignId}`
      clientLogger.info(logDetails)
      const fptiData = {
        page: 'PPBLCampaignRedirectionHelper',
        pageDetails: logDetails,
      }
      trackPage(fptiData)

      navigate(redirectUri)
    }
  }, [])

  return <></>
}

export default PPBLCampaignRedirectionHelper
